"use client";

import type { Palette } from "./data";
import { loc } from "./helpers";

export function PaletteCard({
  palette,
  isSelected,
  onSelect,
  locale,
  activeBadge,
}: {
  palette: Palette;
  isSelected: boolean;
  onSelect: (p: Palette) => void;
  locale: string;
  activeBadge: string;
}) {
  const [c0, c1, c2, c3] = palette.colors;
  const explosionBg = `radial-gradient(ellipse at 0% 0%, ${c0}88 0%, transparent 65%), radial-gradient(ellipse at 100% 0%, ${c1}88 0%, transparent 65%), radial-gradient(ellipse at 100% 100%, ${c2}88 0%, transparent 65%), radial-gradient(ellipse at 0% 100%, ${c3}88 0%, transparent 65%), #0a0a12`;

  return (
    <button
      onClick={() => onSelect(palette)}
      className="group relative w-full overflow-hidden rounded-xl border p-3 text-left transition-all duration-300"
      style={{
        borderColor: isSelected
          ? "rgba(30,63,232,0.7)"
          : "rgba(245,245,247,0.1)",
        background: explosionBg,
        boxShadow: isSelected
          ? `0 0 0 1px rgba(30,63,232,0.5), 0 8px 32px ${c0}33`
          : `0 4px 24px ${c0}22`,
      }}
    >
      <div className="mb-3 flex overflow-hidden rounded-lg">
        {palette.colors.map((color, i) => (
          <div
            key={i}
            className="h-10"
            style={{ background: color, flex: i === 0 ? "2 1 0%" : "1 1 0%" }}
          />
        ))}
      </div>
      <div className="flex items-start justify-between gap-2">
        <div>
          <p
            className="text-sm font-semibold leading-tight"
            style={{ color: "#F5F5F7" }}
          >
            {loc(palette.name, locale)}
          </p>
          <p
            className="mt-0.5 text-xs leading-snug"
            style={{ color: "rgba(245,245,247,0.55)" }}
          >
            {loc(palette.description, locale)}
          </p>
        </div>
        {isSelected && (
          <span
            className="mt-0.5 shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold"
            style={{ background: "rgba(30,63,232,0.3)", color: "#3B7EFF" }}
          >
            {activeBadge}
          </span>
        )}
      </div>
    </button>
  );
}
